<template>
  <div id="app" :class="[page, this.skin]">
    <base-layout/>
  </div>
</template>

<script>
import BaseLayout from './components/layout/BaseLayout'
import util from "@/util";

window.dataLayer = []
window._mtm = []

export default {
  name: 'app',
  components: {
    BaseLayout
  },
  methods: {

    gaInit() {
      // this.$store.state.dataLayerReady = false
      if (!this.$store.state.dataLayerReady) {
        this.$axios.get('/api/trackingCodes?portal=group-booking').then((res) => {
          if (res.code === 200 && res.data.length) {

            //移除重复的script-----start
            // this.gaRemove1()
            //移除重复的script-----end


            const arr = res.data
            arr.forEach((ga) => {
              util.loadJs(ga.script_type, ga.script_code, ga.location)
            })

            //移除重复的script(二级)-----start
            // this.gaRemove2()
            //移除重复的script(二级)-----end

            this.$store.commit('stateChange', {k: 'dataLayerReady', v: true})
          }
        })
      }
    },

    gaRemove1() {
      let doms = document.getElementsByClassName('tracking-codes')
      while (doms.length) {
        doms[0].remove()
      }

    },
    gaRemove2() {
      let gaScript = document.querySelectorAll('script[async][src]')
      if (gaScript.length) {
        let srcs = []
        gaScript.forEach((script) => {
          srcs.push(script.src);
        })
        srcs = [...new Set(srcs)]
        //重复判断
        if (gaScript.length !== srcs.length) {
          srcs.forEach((src) => {
            if (document.querySelectorAll(`script[async][src="${src}"]`).length > 1) {
              document.querySelector(`script[async][src="${src}"]`).remove()
            }
          })
        }
      }
    }


  },
  computed: {
    page() {
      return this.$route.name?.toLocaleLowerCase()
    },
    device() {
      return window.innerWidth
    },
    skin() {
      return this.$store.state.gaData.skinCode
    },
    lang() {
      return this.$store.state.gaData.lang
    },
    UA() {
      const inBrowser = typeof window !== 'undefined';
      const inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
      const weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
      const UA = inBrowser && window.navigator.userAgent.toLowerCase();
      const isIE = UA && /msie|trident/.test(UA);
      const isIE9 = UA && UA.indexOf('msie 9.0') > 0;
      const isEdge = UA && UA.indexOf('edge/') > 0;
      const isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
      const isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
      const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
      const isPhantomJS = UA && /phantomjs/.test(UA);
      const isFF = UA && UA.match(/firefox\/(\d+)/);
      const isMobile = UA && UA.indexOf('mobile') > 0
      const isWechat = UA && UA.indexOf('micromessenger') > 0
      return {
        isIE,
        isIE9,
        isEdge,
        isAndroid,
        isIOS,
        isChrome,
        isPhantomJS,
        isFF,
        inWeex,
        weexPlatform,
        isMobile,
        isWechat,
        UA
      }

    },
  },
  created() {
    if (this.page !== 'payment') {
      localStorage.removeItem("form");
    }
    if(this.skin == 'sjm') {
      document.getElementsByTagName('body')[0].style.fontFamily = 'Lato, Helvetica, Arial, sans-serif';
      document.getElementsByTagName('body')[0].style.color = '#676868';
    }
    this.gaInit()
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', AvenirLTS, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
